import { createFileRoute } from "@tanstack/react-router";
import { VariantRouter } from "@/components/funnel/VariantRouter";
import {
  BRAND_FOUNDER,
  BRAND_LOGO_URL,
  BRAND_META_DESCRIPTION,
  BRAND_META_KEYWORDS,
  BRAND_NAME,
  BRAND_SITE,
} from "@/components/inflow/brand";

export const Route = createFileRoute("/vsl-v3")({
  component: VslV3Page,
  head: () => ({
    meta: [
      { title: BRAND_NAME },
      { name: "description", content: BRAND_META_DESCRIPTION },
      { name: "keywords", content: BRAND_META_KEYWORDS },
      { name: "author", content: `${BRAND_FOUNDER}, CEO of ${BRAND_NAME}` },
      { property: "og:title", content: BRAND_NAME },
      { property: "og:description", content: BRAND_META_DESCRIPTION },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${BRAND_SITE}/vsl-v3` },
      { property: "og:image", content: BRAND_LOGO_URL },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: BRAND_NAME },
      { name: "twitter:description", content: BRAND_META_DESCRIPTION },
      { name: "twitter:image", content: BRAND_LOGO_URL },
    ],
    links: [
      { rel: "canonical", href: `${BRAND_SITE}/vsl-v3` },
      { rel: "preconnect", href: "https://fast.vidalytics.com" },
    ],
    scripts: [
      {
        src: "https://app.usecortana.ai/api/hub/v1/cmq7mzo9r00dsko0csx8o3gm1",
        async: true,
      },
    ],
  }),
});

function VslV3Page() {
  return <VariantRouter path="/vsl-v3" />;
}
